















import { ScatterChartOptions } from '@/api/model/ApexChartOptions';
import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class ScatterChart extends Vue {
    @Prop({ type: Number, default: 10 })
    xMax!: number;
    @Prop({ type: Number, default: 50 })
    maxTitleLength: number;
    @Prop({ type: Number, default: 50 })
    maxAxisTitleLength!: number;
    /**
     * Reset chart
     */
    @Prop({ type: Boolean, default: false })
    public resetChart!: boolean;

    @Prop({
        type: Object,
        default: () => ({
            data: {
                series: [],
            },
            title: {
                text: '',
            },
            xaxis: {
                factor_name: '',
                scoring_labels: [],
            },
            yaxis: {
                factor_name: '',
                scoring_labels: [],
            },
        }),
    })
    chartData!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 400 })
    public height!: number;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 600 })
    public width!: number;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Boolean, default: false })
    stacked!: boolean;

    /**
     * initialize
     */
    mounted() {}

    get chartOptions() {
        let chartOptions: ScatterChartOptions = {
            chart: {
                type: 'scatter',
                redrawOnWindowResize: false,
                redrawOnParentResize: false,
                offsetY: 0,
                offsetX: 0,
                width: 66,
                height: 100,
                // toolbar: {
                //     show: false,
                // },
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true || '<img src="/static/icons/reset.png" width="20">',
                        customIcons: [],
                    },
                    export: {
                        csv: {
                            filename: undefined,
                            columnDelimiter: ',',
                            headerCategory: 'category',
                            headerValue: 'value',
                            dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString();
                            },
                        },
                        svg: {
                            filename: undefined,
                        },
                        png: {
                            filename: undefined,
                        },
                    },
                    autoSelected: 'zoom',
                },
            },
            dataLabels: {
                enabled: false,
                formatter: function (val: any) {
                    return String(val ? val.toFixed(1) : '');
                },
                offsetY: 0,
                style: {
                    fontSize: '14px',
                    colors: ['#ffffff'],
                },
            },
            xaxis: {
                min: 0,
                max: 100,
                type: 'numberic',
                position: 'bottom',
                tickAmount: 10,
                title: {
                    text: this.chartData.xaxis.factorName,
                    // text: this.chartData.xaxis.factorName.length > this.maxAxisTitleLength ?
                    //         this.chartData.xaxis.factorName.substring(0, this.maxAxisTitleLength) :
                    //         this.chartData.xaxis.factorName,
                    style: {
                        fontSize: '14px',
                        fontWeight: 600,
                        fontFamily: 'Nunito, Helvetica, Arial, sans-serif'
                    }
                },
                labels: {
                    show: true,
                    style: {
                        colors: ['#0A4B71'],
                        fontSize: '14px',
                        fontFamily: 'Nunito, Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                    },
                    formatter: (val) => val.toFixed(0) + '%',
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: true,
                },
                // crosshairs: {
                //     fill: {
                //         type: 'gradient',
                //         gradient: {
                //             colorFrom: '#D8E3F0',
                //             colorTo: '#BED1E6',
                //             stops: [0, 100],
                //             opacityFrom: 0.4,
                //             opacityTo: 0.5,
                //         },
                //     },
                // },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                min: 0, //this.chartData.yaxis.min,
                max: 100, //this.chartData.yaxis.max,
                type: 'numberic',
                tickAmount: 10,
                title: {
                    text: this.chartData.yaxis.factorName.length > this.maxAxisTitleLength ?
                            this.chartData.yaxis.factorName.substring(0, this.maxAxisTitleLength) + '...' :
                            this.chartData.yaxis.factorName,
                    style: {
                        fontSize: '14px',
                        fontWeight: 600,
                        fontFamily: 'Nunito, Helvetica, Arial, sans-serif'
                    }
                },
                labels: {
                    show: true,
                    style: {
                        colors: '#0A4B71',
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 400
                    },
                    formatter: function (data: any) {
                        if (typeof data == 'string') {
                            return data.length >= 20 ? data.substring(0, 17) + '...' : data;
                        } else if (typeof data == 'number') {
                            return data.toFixed(0) + '%';
                        }
                    }                  
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: true,
                },
                
            },
            title: {
                text:
                    this.chartData.title.text.length > this.maxTitleLength
                        ? this.chartData.title.text.substring(0, this.maxTitleLength) + '...'
                        : this.chartData.title.text,
                align: 'center',
                style: {
                    color: '#0A4B71',
                },
            },
            tooltip: {
                enabled: true,
            },
            grid: {
                show: true,
                borderColor: '#D2DAE1',  //'#F0F8FF',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
                yaxis: {
                    lines: {
                        show: true,
                    },
                },
                row: {
                    colors: undefined,
                    opacity: 0.9,
                },
                column: {
                    colors: undefined,
                    opacity: 0.9,
                },
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 14,
                },
            },
        };
        return chartOptions;
    }

    /**
     * Default Options
     */
    private applyDefaultOptions() {
        return;
    }

    /**
     * onClick
     */
    private onClick(event?: MouseEvent | undefined, activeElements?: {}[] | undefined): any {}

    /**
     * Reset chart position
     */
    @Watch('')
    private resetChartPosition() {}

    /**
     * click a chart element
     */
    @Emit('click-chart-element')
    public clickChartElement(element: any) {
        return element;
    }
}
